import { render, staticRenderFns } from "./SpecialDialog.vue?vue&type=template&id=4a722c54&scoped=true&"
import script from "./SpecialDialog.vue?vue&type=script&lang=js&"
export * from "./SpecialDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpecialDialog.vue?vue&type=style&index=0&id=4a722c54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a722c54",
  null
  
)

export default component.exports